import { Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  className?: string;
}

const ModificationRequestUnSupportedDeviceCard: FC<Props> = ({ className }) => (
  <div className={className}>
    <Typography>
      <FormattedMessage id="modification_request.unsupported_device_card.description" />
    </Typography>
  </div>
);

export default ModificationRequestUnSupportedDeviceCard;
